import { PlaceS } from '../data/model'

export function serializeS(place: PlaceS): string {
  const serialized = JSON.stringify(place)
    .replace(/:/g, '=')
    .replace(/,/g, ';')
    .replace(/"/g, '')
    .replace(/{/g, '')
    .replace(/}/g, '')
  const encoded = window.btoa(serialized)
  return `s-${encoded}`
}
